module.exports = __webpack_public_path__ + "static/media/dark_icn_map_fermata_ls_capolinea_selected.35e2612c.svg";